module.exports = __webpack_public_path__ + "img/PT5190.a7fceb78.png";